module.exports = __webpack_public_path__ + "img/announcement.65988863.svg";